import { Field, FieldProps } from 'formik';
import React from 'react';
import { Grid } from '@mui/material';
import moment from 'moment';
import SharedMobileTimePicker from '../../common/ui/SharedMobileTimePicker';
import { StyledErrorMessage } from '../StyledErrorMessage';
import { FormElementProps, getShouldMarkFieldAsUpdated } from './utils';

type FormTimePickerProps = FormElementProps & {
  minTime?: moment.Moment;
  width?: number;
};

export const FormTimePicker = ({ disabled, fieldName, minTime, label, isFieldUpdate, width }: FormTimePickerProps) => {
  return (
    <Grid container width={width} justifyContent="flex-start">
      <Grid item>
        <Field name={fieldName}>
          {({ field, form }: FieldProps<string | number>) => {
            const shouldMarkFieldAsUpdated = getShouldMarkFieldAsUpdated(form, fieldName, field, isFieldUpdate);

            return (
              <SharedMobileTimePicker
                field={field}
                showUpdatedStyling={shouldMarkFieldAsUpdated}
                value={+field.value}
                disabled={disabled}
                minutesStep={15}
                onChange={(newValue) =>
                  form.setFieldValue(fieldName, newValue!.hours() * 3600 + newValue!.minutes() * 60)
                }
                minTime={minTime}
                label={label}
              />
            );
          }}
        </Field>
        <StyledErrorMessage name={fieldName} />
      </Grid>
    </Grid>
  );
};
